<template>
  <div class="us_app">
    <section class="user_section">
      <div class="title jc">
        <h2>환자 상세 정보</h2>
      </div>

      <article class="view">
        <div class="table_list">
          <h3 class="tb_title">환자 정보</h3>
          <table class="write">
            <colgroup>
              <col width="200" />
              <col width="30%" />
              <col width="200" />
              <col width="30%" />
            </colgroup>
            <tbody>
              <tr>
                <th>차트번호</th>
                <td><span>{{patientInfo.patient_chart_no}}</span></td>
                <th>성별</th>
                <td><span>{{patientInfo.patient_gender_nm}} </span></td>
              </tr>
              <tr>
                <th>성명</th>
                <td>
                  <span>{{patientInfo.patient_nm}}</span>
                </td>
                <th>생년월일</th>
                <td>
                <span>{{formatDate_YYYYMMDD(patientInfo.patient_birthday)}}</span>
                </td>
              </tr>
              <tr>
                <th>연락처</th>
                <td>
                  <span>{{ formatPhoneNumber(patientInfo.patient_tel_num) }}</span>
                </td>
                <th>나이</th>
                <td><span>{{patientInfo.patient_age}} </span></td>
              </tr>
              <tr>
                <th>우편번호</th>
                <td>
                  <span>{{ patientInfo.patient_post_no }}</span>
                </td>
                <th>마지막 처방일</th>
                <td>
                  <span>{{ patientInfo.last_prescribe_dt }}</span>
                </td>
              </tr>
              <tr>
                <th>주소</th>
                <td>
                  <span>{{patientInfo.patient_addr}} {{patientInfo.patient_addr_dtl}}</span>
                </td>
              </tr>
              <tr>
                <th>환자비고</th>
                <td>
                  <span>{{patientInfo.patient_note}}</span>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="bottom_box">
            <button class="btn btn_md btn_darkbrown" @click="fn_move_list_page">
              목록
            </button> 
            <div class="btn_box">
                  <button class="btn btn_md btn_brown" @click="fn_move_mod_page">수정</button>
            </div> 
          </div>
        </div>
      </article>
    </section>
  </div>
</template>

<script>

import axios from 'axios'
import commonUtil from "@/mixin/commonUtil";

export default {
  components: {

  },
  mixins: [commonUtil],
  data() {
    return {
      patient_seq : '',
      clinic_doctor_id : '',
      patientInfo : {},     
    };
  },
  created(){
    this.patient_seq = this.$store.getters['detailSearchInfo/getSearchId']
    this.clinic_doctor_id = this.$store.getters['clinicDoctorInfo/getClinicDoctorId'];
  },
  mounted(){
    this.fn_search();
  },
  methods: {
    fn_search(){

          //환자seq 정보 셋팅
          let param = new Object();
          param.patient_seq = this.patient_seq;
          param.clinic_doctor_id = this.clinic_doctor_id;

          //환자정보 상세조회
          axios
              .post("/api/user/mypage/getPatientDetail", param)
              .then((res) => {
                  console.log("@@@@ res : %o",res);
                  this.patientInfo = res.data.patientInfo;
              })
              .catch((err) => console.log(err));
              
      },
      fn_move_list_page(){
          this.$store.dispatch('detailSearchInfo/setSearchId', ''); 
          this.$router.push("/mypage/patientMngt");
      },
      fn_move_mod_page(){
          this.$store.dispatch('detailSearchInfo/setStatus', 'M'); 
          this.$router.push("/mypage/patientReg");
      },
  },
};
</script>
